"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordFieldByConfig = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _components = require("../../components");
var _utils = require("../../utils");
var _SharedStyledComponents = require("../SharedStyledComponents");
var _PasswordRequirements = require("./PasswordRequirements");
var _PasswordToggle = require("./PasswordToggle");
var _jsxRuntime = require("react/jsx-runtime");
const defaultMaxLength = 255;
const defaultMinLength = 6;
const getPasswordRequirements = (minLength, maxLength, configRequirements) => {
  const correctRequirements = [];
  if (configRequirements?.lowercaseLetter?.isRequired) {
    correctRequirements.push({
      key: 'passwordRequirementLowerCaseLetter',
      validationRegex: new RegExp(configRequirements.lowercaseLetter.regularExpression ?? '')
    });
  }
  if (configRequirements?.uppercaseLetter?.isRequired) {
    correctRequirements.push({
      key: 'passwordRequirementUpperCaseLetter',
      validationRegex: new RegExp(configRequirements.uppercaseLetter.regularExpression ?? '')
    });
  }
  correctRequirements.push({
    key: 'passwordRequirementCharactersCount',
    validationRegex: new RegExp(`^.{${minLength},${maxLength}}$`)
  });
  if (configRequirements?.digit?.isRequired) {
    correctRequirements.push({
      key: 'passwordRequirementDigit',
      validationRegex: new RegExp(configRequirements.digit.regularExpression ?? '')
    });
  }
  if (configRequirements?.specialCharacter?.isRequired) {
    correctRequirements.push({
      key: 'passwordRequirementSpecialCharacter',
      validationRegex: new RegExp(configRequirements.specialCharacter.regularExpression ?? '')
    });
  }
  return correctRequirements;
};
const PasswordFieldByConfig = props => {
  const {
    name,
    label,
    isEditable,
    isAvailable,
    displayOrder,
    isMandatory,
    requirements,
    initialValue,
    customPlaceholder,
    variant,
    isSubmitting,
    customErrors,
    autoFocus,
    customMaxWidth,
    centeredBoxContent = true
  } = props;
  const [isPasswordVisible, setIsPasswordVisible] = (0, _react.useState)(false);
  const [isShowRequirements, setIsShowRequirements] = (0, _react.useState)(false);
  const [isValidatingRequirements, setIsValidatingRequirements] = (0, _react.useState)(false);
  const {
    getTestIdProps,
    getTestId
  } = (0, _testidGenerator.default)();
  const submitError = customErrors?.find(error => error.fieldName?.toLowerCase() === name.toLowerCase());
  const errorMessage = submitError ? (0, _utils.getErrorLocalizationByCode)(submitError?.errorCode, name) : undefined;
  const minLength = props?.minLength ?? defaultMinLength;
  const maxLength = props?.maxLength ?? defaultMaxLength;
  const passwordRequirementsArray = getPasswordRequirements(minLength, maxLength, requirements);

  // we need start tabindex from 1 but displayOrder starts from 0
  const correctTabIndex = typeof displayOrder === 'number' ? displayOrder + 1 : displayOrder;
  const renderField = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12,
      sm: 12
    },
    style: {
      order: displayOrder
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      margin: centeredBoxContent ? '0 auto 20px' : '0 0 20px',
      maxWidth: customMaxWidth ?? 500,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
        name: name,
        defaultValue: initialValue,
        render: ({
          field,
          fieldState
        }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SharedStyledComponents.StyledFormControl, {
          fullWidth: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
            fullWidth: true,
            label: label,
            variant: variant ?? 'outlined',
            type: isPasswordVisible ? 'text' : 'password',
            placeholder: customPlaceholder ?? '',
            error: !!fieldState.error || Boolean(submitError),
            helperText: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              children: [errorMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ErrorMessage, {
                errorMessage: errorMessage
              }) : null, !isShowRequirements && fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                ...getTestIdProps(`${name}-password-field-error-message`),
                children: fieldState.error.message
              }) : null, isShowRequirements && requirements ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                ...getTestIdProps(`${name}-password-field-requirements`),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordRequirements.PasswordRequirements, {
                  minChar: props?.minLength,
                  requirements: passwordRequirementsArray,
                  validating: isValidatingRequirements,
                  actualValue: field.value
                })
              }) : null]
            }),
            disabled: !isEditable || isSubmitting,
            required: isMandatory,
            defaultValue: field.value,
            inputProps: {
              autoFocus,
              tabIndex: correctTabIndex,
              'data-testid': getTestId(`${name}-password-field`)
            }
            // eslint-disable-next-line react/jsx-no-duplicate-props --- we needed is not duplicate props
            ,
            InputProps: {
              endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordToggle.PasswordToggle, {
                tabIndex: correctTabIndex,
                isShowPassword: isPasswordVisible,
                setPasswordVisible: setIsPasswordVisible
              }),
              autoComplete: 'new-password',
              autoFocus
            },
            onFocus: _e => setIsShowRequirements(true),
            onKeyUp: _e => setIsValidatingRequirements(true),
            ...field
          })
        })
      })
    })
  });
  const fieldComponent = isAvailable && renderField();
  return fieldComponent;
};
exports.PasswordFieldByConfig = PasswordFieldByConfig;
